import { formatNotificacion } from './notificacionFormat';
import './NotificacionesPanel.css';

/**
 * Lista de notificaciones no leídas. Al clickear una se la marca como leída.
 * @param {{ notificaciones: object[], onItemClick: (id: string) => void, onMarcarTodas: () => void }} props
 */
function NotificacionesPanel({ notificaciones = [], onItemClick, onMarcarTodas }) {
  if (notificaciones.length === 0) {
    return (
      <div className="notif-panel--empty">
        No tenés notificaciones nuevas.
      </div>
    );
  }

  return (
    <div className="notif-panel">
      <div className="notif-panel__header">
        <h3 className="notif-panel__title">Notificaciones no leídas</h3>
        <button
          type="button"
          className="notif-panel__marcar-todas"
          onClick={onMarcarTodas}
        >
          Marcar todas como leídas
        </button>
      </div>
      <ul className="notif-panel__list">
        {notificaciones.map((noti) => {
          const { titulo, descripcion, fecha } = formatNotificacion(noti);
          return (
            <li key={noti._id}>
              <button
                type="button"
                className="notif-item"
                onClick={() => onItemClick(noti._id)}
              >
                <p className="notif-item__titulo">{titulo}</p>
                <p className="notif-item__descripcion">{descripcion}</p>
                {fecha && <span className="notif-item__fecha">{fecha}</span>}
              </button>
            </li>
          );
        })}
      </ul>
    </div>
  );
}

export default NotificacionesPanel;
